module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgements"
    }
  }, [_c('h1', [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', [_vm._v("The first three chapters of this novel, in a somewhat different form, appeared in "), _c('em', [_vm._v("Be Untexed")]), _vm._v(", a Burma-based online journal of new writings and visual arts. For this, I thank the editors of the journal.")]), _vm._v(" "), _c('p', [_vm._v("My special thanks go to my niece, Theint, for helping me financially to finish and publish this book, and to artist Maung Di for encouraging me to publish this book.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1f3df42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch004.vue
// module id = 72
// module chunks = 0